/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/api/request'; // 获取服务款项

export function getServiceAmount(data) {
  return request.get('/settlement/details', {
    params: data
  });
} // 编辑款项

export function getEditAmount(data) {
  return request.post('/settlement/saveSettlement', data);
}